export default __webpack_public_path__ + "static/media/jerry2.30ed58e2.jpg";